import {makeTwoDigit} from './generator'

export const splitDate = (dateString: string | number | Date = '') => {
  const date = new Date(dateString)
  const dateStr = date.toDateString().split(' ')
  const timeStr = date.toLocaleTimeString().split(':')
  return {
    day: dateStr[0],
    dd: dateStr[2],
    mm: String(date.getMonth() + 1),
    MM: dateStr[1],
    yyyy: dateStr[3],
    hour: timeStr[0],
    minute: timeStr[1],
    second: timeStr[2]?.split(' ')?.[0] || '',
    ampm: timeStr[2]?.split(' ')?.[1] || '',
  }
}

export const generateDateFormat = (date: string | number | Date, format: string) => {
  if (!date) return ''
  const dateTime = splitDate(date)
  return format
    .replace('%day%', dateTime?.day || '0')
    .replace('%dd%', dateTime?.dd || '0')
    .replace('%mm%', makeTwoDigit(dateTime?.mm) || '0')
    .replace('%MM%', dateTime?.MM || '0')
    .replace('%yyyy%', dateTime?.yyyy || '0')
    .replace('%hour%', makeTwoDigit(dateTime?.hour) || '0')
    .replace('%minute%', makeTwoDigit(dateTime?.minute) || '0')
    .replace('%second%', makeTwoDigit(dateTime?.second) || '0')
    .replace('%ampm%', dateTime?.ampm || 'N/A')
}

export const addRemoveDays = (date, days, isAdd = true) => {
  date = date ? new Date(date) : new Date()
  return isAdd
    ? new Date(date.getTime() + days * 24 * 60 * 60 * 1000)
    : new Date(date.getTime() - days * 24 * 60 * 60 * 1000)
}

export const makeInputDateFormate = (date) =>
  `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(
    -2
  )}`

export const makeEndDate = (date) => `${date}T23:59:59` // '2022-12-22' => '2022-12-22T23:59:59'
